import { IconButton } from '../../../../../common/components/iconButton/IconButton'
import { SaleItemInterface } from '../../../../../common/types/interfaces'
import del from '../../../../../assets/images/icons/trash.svg'
import classes from './RelationList.module.sass'

type Props = {
  items?: { relationId: number }[]
  saleItemList: SaleItemInterface[]
  onRemove: (relationId: number) => void
  getItemDisplayText: (item: SaleItemInterface) => string
  title: string
}

export const RelationList = ({
  items,
  saleItemList,
  onRemove,
  getItemDisplayText,
  title,
}: Props) => {
  if (!items?.length) return null

  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>
      <div className={classes.list}>
        {items.map((item) => {
          const product = saleItemList.find((p) => p.id === item.relationId)
          if (!product) return null

          return (
            <div className={classes.item} key={item.relationId}>
              <span>{getItemDisplayText(product)}</span>
              <IconButton
                onClick={() => onRemove(item.relationId)}
                alt="Удалить"
                display
                icon={del}
                small
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}
